module.exports = __webpack_public_path__ + "static/media/Logo.b1d90e33.svg";